import axios from "axios";
import { BASE_ENDPOINT } from "../helpers/Config";

const EXCHANGER_LIST_URL = `${BASE_ENDPOINT}/admin/exchanger-list`;

/**
 * POST /admin/exchanger-list
 * @param {import("../types/exchangerList").ExchangerListParams} params
 * @returns {Promise<import("../types/exchangerList").ExchangerListResponse | import("../types/exchangerList").ExchangerListErrorResponse>}
 */
export async function fetchExchangerList({ token, query = "", page_no = 1 }) {
    const res = await axios({
        method: "post",
        url: EXCHANGER_LIST_URL,
        headers: { "Content-Type": "application/json" },
        data: {
            token,
            query: query ?? "",
            page_no,
        },
    });
    return res?.data;
}
